export default __webpack_public_path__ + "static/media/acceso-camara-mac-1.11efc9a7.svg";